import styled from "styled-components";

export const MainContainer = styled.div`

`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 50px;
  .sc-grREDI.bTBcPb:last-of-type {
    display: none !important;
  }
  @media (max-width: 575px) {
    .sc-grREDI.bTBcPb:last-of-type {
      display: none !important;
    }
  }

  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const NumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
`;

export const Number = styled.h1`
  font-size: calc(3em + 1vw) !important;
  font-family: Poppins-Medium;
  color: #ffffff;
  margin-bottom: unset;
`;

export const Title = styled.h3`
  font-size: 42px;
  font-family: Poppins-Light;
  color: #ffffff;
  margin-bottom: unset;
`;

export const Description = styled.p`
  font-size: 18px;
  font-family: Poppins-Light;
  color: #ffffff;
  margin-bottom: unset;
  text-align: center;
`;

export const Container = styled.div`
  background-color: #ffc500;
  width: 100%;
  height: auto;
  margin-bottom: 50px;
  margin-top: 100px;
  overflow: hidden;
  @media (max-width: 575px) {
    height: auto;
  }
`;

export const VerticalLine = styled.div`
  border-left: 2px solid #ffffff;
  height: 272px;
  @media (max-width: 575px) {
    border-top: 2px solid #ffffff;
    border-left: none;
    height: unset;
  }
    #root > div:nth-child(5) > div:nth-child(1) > div > div:nth-child(6){
display:none;
})
`;
